// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__168XP","bigColWidth":"Table_bigColWidth__2uyMx","biggerColWidth":"Table_biggerColWidth__29TCd","row":"Table_row__3YLgd","col":"Table_col__y41Yk"};